import { OUT_OF_STOCK } from "../screens/pages/shop/constants";
export const getDefaultVariant = (variations) => {
    const inStockVariants = variations.filter((v) => v.status !== OUT_OF_STOCK);
    const defaultVariant = inStockVariants?.find((v) => v.is_default === true) || inStockVariants?.at(0);
    return defaultVariant;
};
